// Pure derivation of WHY the list is empty, so `InboxList` can show the
// right copy (docs/06-ux-rules.md "Per-pane states": "empty scoped by
// filter combination"; 11-chassis-plan.md §2 PR 04: "empty-by-cause"
// `open+feedback`, `open+recovery_ai`, `resolved`, `search`, `location`).
//
// Precedence (most specific wins, since several can be true at once — e.g.
// a search AND a location filter both active): a search query is the most
// specific "why nothing matched" explanation, then an active location
// filter, then the status/kind combination. `status=resolved` doesn't
// distinguish kind (no `resolved+feedback` / `resolved+recovery_ai` copy
// exists in the doc's cause list). `kind=all` under `status=open` gets its
// own `open_all` cause (review finding #7) rather than falling back to
// `open_feedback`'s copy — Kind=All also includes RecoveryAI escalations,
// so the feedback-only "no order feedback needs a response" copy
// underclaims what's actually empty.
import type { InboxKind, InboxStatus } from 'api/feedbackInbox.types'

export type EmptyStateCause =
  | 'search'
  | 'location'
  | 'resolved'
  | 'open_recovery_ai'
  | 'open_all'
  | 'open_feedback'

export interface EmptyStateCauseParams {
  q: string
  locationIds: number[]
  status: InboxStatus
  kind: InboxKind
}

export function emptyStateCause({
  q,
  locationIds,
  status,
  kind,
}: EmptyStateCauseParams): EmptyStateCause {
  if (q.trim().length > 0) return 'search'
  if (locationIds.length > 0) return 'location'
  if (status === 'resolved') return 'resolved'
  if (kind === 'recovery_ai') return 'open_recovery_ai'
  if (kind === 'all') return 'open_all'
  return 'open_feedback'
}
